import classNames from 'classnames'

import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  nbMaxCharacters: number
  text: string
}

const CharacterCount = ({ nbMaxCharacters, text }: Props): ReactElement => {
  const classes = classNames('character-count-component', {
    'character-count-component--error': text.length > nbMaxCharacters,
  })

  return (
    <div className={classes}>
      <span>
        {text.length} / {nbMaxCharacters}
      </span>
    </div>
  )
}

export default CharacterCount
